// Системные метастатусы постов (контекст posts). Пользовательские статусы блога
// привязываются к одному из них; на метастатусах держится логика планирования.
export enum MetaStatus {
  /** Не опубликован, в работе — планировать нельзя. */
  Draft = 'draft',
  /** Не опубликован, готов — можно ставить в очередь и на время (SCH-RULE-1). */
  Ready = 'ready',
  /** Опубликован, актуален. */
  Published = 'published',
  /** Неактуален или удалён — план снимается (POST-UC-5). */
  Retired = 'retired',
}

export const META_STATUSES: readonly MetaStatus[] = [MetaStatus.Draft, MetaStatus.Ready, MetaStatus.Published, MetaStatus.Retired];

export function isMetaStatus(value: unknown): value is MetaStatus {
  return META_STATUSES.includes(value as MetaStatus);
}

/** Метастатусы, при переходе в которые план поста снимается (POST-UC-5, PUB-UC-1.CC-1). */
export function withdrawsFromPublication(meta: MetaStatus): boolean {
  return meta === MetaStatus.Draft || meta === MetaStatus.Retired;
}

/** Метастатусы, из которых первая отметка выхода переводит пост в published (PUB-UC-3). */
export function isUnpublished(meta: MetaStatus): boolean {
  return meta === MetaStatus.Draft || meta === MetaStatus.Ready;
}

export interface DefaultStatus {
  name: string;
  color: string;
  meta: MetaStatus;
}

/** WS-UC-1: статусы нового блога. */
export const DEFAULT_POST_STATUSES: readonly DefaultStatus[] = [
  { name: 'Черновик', color: '#9CA3AF', meta: MetaStatus.Draft },
  { name: 'Готов', color: '#22C55E', meta: MetaStatus.Ready },
  { name: 'Опубликован', color: '#3B82F6', meta: MetaStatus.Published },
  { name: 'Неактуален', color: '#78716C', meta: MetaStatus.Retired },
];

export const STATUS_COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/;
export const STATUS_NAME_MAX_LENGTH = 50;
